// modules
import { useCallback, useEffect, useState } from "react";

import { Form } from "antd";

// service calls
import { getReservedNonMembers, createNonMembersAccount } from "services/api/nonMemberAccount";
// components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";
import ModalContainer from "components/molecules/ModalContainer/ModalContainer";

// constants and types

import { FormInstance } from "antd/es/form/Form";

import dayjs from "dayjs";

// for dayjs

import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(weekday);
dayjs.extend(localeData);
type AdhocReportPropTypes = {
	createAccount: () => void;
	loading: boolean;
	form: FormInstance;
	quantityAo: number;
	quantityGo: number;
	quantityAhcs: number;
	errorQuantityAo: boolean;
	errorQuantityGo: boolean;
	errorQuantityAhcs: boolean;
	errorMessageQuantityAo: string;
	errorMessageQuantityGo: string;
	errorMessageQuantityAhcs: string;
	reservedCounts: ReservedNonMembers;
	handleQuantityAo: (s: number) => void;
	handleQuantityGo: (s: number) => void;
	handleQuantityAhcs: (s: number) => void;
	proceed: () => void;
	resetFields: () => void;
};

type ReservedNonMembers = {
	non_member_ahcs: number;
	non_member_ao: number;
	non_member_go: number;
};

const initialValueReserved = {
	non_member_ahcs: 0,
	non_member_ao: 0,
	non_member_go: 0
};

export function useNonMemberAccountPage(): AdhocReportPropTypes {
	const [form] = Form.useForm();

	const [loading] = useState<boolean>(false);

	const [errorMessageQuantityAo, setErrorMessageQuantityAo] = useState<string>("");
	const [errorMessageQuantityGo, setErrorMessageQuantityGo] = useState<string>("");
	const [errorMessageQuantityAhcs, setErrorMessageQuantityAhcs] = useState<string>("");
	const [errorQuantityAo, setErrorQuantityAo] = useState<boolean>(false);
	const [errorQuantityGo, setErrorQuantityGo] = useState<boolean>(false);

	const [errorQuantityAhcs, setErrorQuantityAhcs] = useState<boolean>(false);
	const [quantityAo, setQuantityAo] = useState<number>(0);
	const [quantityGo, setQuantityGo] = useState<number>(0);
	const [quantityAhcs, setQuantityAhcs] = useState<number>(0);
	const [reservedCounts, setReservedCounts] = useState<ReservedNonMembers>(initialValueReserved);

	const handleQuantityAo = useCallback(
		(num: number) => {
			setQuantityAo(num);
			if (num > 1000) {
				setErrorQuantityAo(true);
				setErrorMessageQuantityAo("Enter a value between 0-1000");
				return;
			}

			setErrorQuantityAo(false);
		},
		[quantityAo, errorMessageQuantityAo, errorQuantityAo]
	);
	const handleQuantityAhcs = useCallback(
		(num: number) => {
			setQuantityAhcs(num);
			if (num > 1000) {
				setErrorQuantityAhcs(true);
				setErrorMessageQuantityAhcs("Enter a value between 0-1000");
				return;
			}

			setErrorQuantityAhcs(false);
		},
		[quantityAhcs, errorMessageQuantityAhcs, errorQuantityAhcs]
	);

	const handleQuantityGo = useCallback(
		(num: number) => {
			setQuantityGo(num);
			if (num > 1000) {
				setErrorQuantityGo(true);
				setErrorMessageQuantityGo("Enter a value between 0-1000");
				return;
			}

			setErrorQuantityGo(false);
		},
		[quantityGo, errorMessageQuantityGo, errorQuantityGo]
	);

	useEffect(() => {
		callReservedNonMembers();
	}, []);

	const callReservedNonMembers = async () => {
		const { data: nonMembersData } = await getReservedNonMembers();
		const { data } = nonMembersData;
		if (!data) {
			return;
		}
		const ao = data.find((x: any) => x.source === "non_member_ao");
		const go = data.find((x: any) => x.source === "non_member_go");
		const ahcs = data.find((x: any) => x.source === "non_member_ahcs");
		const newVal = {
			non_member_ahcs: ahcs.total,
			non_member_ao: ao.total,
			non_member_go: go.total
		};

		setReservedCounts(newVal);

		return data;
	};
	const showModal = (title: string, error = false) => {
		CountDownModal({
			timer: 3,
			title,
			errorIcon: error
		});
	};
	const resetFields = () => {
		setQuantityAhcs(0);
		setQuantityAo(0);
		setQuantityGo(0);
		form.setFieldValue("quantityAo", 0);
		form.setFieldValue("quantityGo", 0);
		form.setFieldValue("quantityAhcs", 0);
	};
	const proceed = async () => {
		const wrong = "Something went wrong.";
		const payload = {
			non_member_ahcs: quantityAhcs,
			non_member_ao: quantityAo,
			non_member_go: quantityGo
		};
		try {
			const { data: reportsData } = await createNonMembersAccount(payload);
			const { errors, data } = reportsData;
			if (!data) {
				showModal(errors[0].message || wrong, true);
				return;
			}
			showModal("CSV report successfully generated.");
			window.open(data.file_url, "_blank");
			resetFields();
		} catch (e: any) {
			showModal(e.response?.data?.errors[0]?.message || wrong, true);
		}
	};
	const createAccount = async () => {
		const errorMessages: string[] = [];
		if (quantityAhcs == 0 && quantityAo == 0 && quantityGo == 0) {
			errorMessages.push("Required to create at least 1 in any non-member accounts.");
		}

		if (quantityAhcs > 1000) {
			setErrorQuantityAhcs(true);
			setErrorMessageQuantityAhcs("Enter a value between 0-1000");
			errorMessages.push("non_member_ahcs fileds should enter a value between 0-1000");
		}
		if (quantityAo > 1000) {
			setErrorQuantityAo(true);
			setErrorMessageQuantityAo("Enter a value between 0-1000");
			errorMessages.push("non_member_ao fileds should enter a value between 0-1000");
		}
		if (quantityGo > 1000) {
			setErrorQuantityGo(true);
			setErrorMessageQuantityGo("Enter a value between 0-1000");
			errorMessages.push("non_member_go fileds should enter a value between 0-1000");
		}

		if (errorMessages.length > 0) {
			showModal(errorMessages[0], true);
			return;
		}
		ModalContainer({
			type: "confirm",
			title: "Accout Creation",
			subtitle: "Proceed to create accounts?",
			confirmButton: {
				label: "Proceed",
				onClick: () => {
					proceed();
				}
			},
			cancelButton: {
				label: "Go Back",
				onClick: () => {
					return;
				}
			}
		});
	};

	return {
		createAccount,
		proceed,
		resetFields,
		loading,
		form,
		quantityAo,
		quantityGo,
		quantityAhcs,
		errorQuantityAo,
		errorQuantityGo,
		errorQuantityAhcs,
		errorMessageQuantityAo,
		errorMessageQuantityGo,
		errorMessageQuantityAhcs,
		handleQuantityAo,
		handleQuantityGo,
		handleQuantityAhcs,
		reservedCounts
	};
}
